export interface KKToastProps {
  content: string;
  /** 默认 success */
  type?: 'success' | 'warn' | 'error';
  /** 出现时长，单位ms，默认3000 */
  duration?: number;
}

export interface KKToastInnerProps extends KKToastProps {
  key: string;
}


export type ShowToastFunc = (params: KKToastProps | string) => void;

export const injectKey = Symbol('kk-toast');
